<script>
	import { topics } from "../data";
	import { getBrightness, darken, rgbStringToHex } from "../../../utils";

	export let topicId;
	export let small = false;
	export let shortLabel = false;
	export let colored = false;
	export let outlined = false;
	export let onClick = undefined;
	export let onClose = undefined;
	export let showCloseButton = true;
	export let showCount = false;
	export let hoverTitle = undefined;

	let topicData;
	let color;
	let label;
	let count;

	const ensureReadableWithWhiteText = (color) => {
		// Calculate the perceived brightness of the color.
		let brightness = getBrightness(color);

		if (brightness > 180) {
			const hex = color.startsWith("#") ? color : rgbStringToHex(color);
			let darkenedColor = darken(hex, 0.1); // you can adjust the amount to darken as needed
			return darkenedColor.toString();
		} else {
			return color;
		}
	};

	$: {
		if ($topics.length && topicId) {
			if (topicId === "sonstiges") {
				label = "Sonstiges";
			} else {
				topicData = $topics.find(({ id }) => topicId === id);
				if (topicData) {
					color = ensureReadableWithWhiteText(topicData.color);
					label = shortLabel || small ? topicData.labelShort : topicData.label;
					count = topicData.count;
				}
			}
		}
	}
</script>

{#if topicData || label}
	<div
		class="topic"
		class:colored
		class:small
		class:outlined
		class:padded={outlined || colored}
		class:clickable={!!onClick}
		style="--topic-color: {color}"
		title={hoverTitle}
		on:click={onClick}
	>
		<div class="text">
			{label}
			{#if showCount}
				<div class="count">{count}</div>
			{/if}
		</div>

		{#if !!onClose && showCloseButton}
			<div class="button-close" on:click={onClose} />
		{/if}
	</div>
{/if}

<style lang="scss">
	.topic {
		color: $white;
		font-size: 13px;
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.outlined.padded {
		&.colored {
			font-weight: $medium;
			padding-right: 2px;
		}

		@media (hover: hover) {
			&:not(.colored):hover {
				background: rgba(246, 246, 246, 0.3);
			}
		}
	}

	.outlined {
		border-radius: 16px;
		border: 1px solid $white;
	}

	.padded {
		padding: 2px 8px;
		box-sizing: border-box;
	}

	.colored {
		background-color: var(--topic-color);
		border-radius: 16px;
		display: inline-flex;

		&.outlined {
			border-color: var(--topic-color);
		}
	}

	.small {
		font-size: 11px;
		font-weight: $medium;
		white-space: nowrap;
		line-height: 120%; /* 13.2px */
		letter-spacing: 0.11px;
		margin: 2px;
		padding: 2px 5px;
		text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
	}

	.clickable {
		cursor: pointer;

		@media (hover: hover) {
			&:hover {
				opacity: 0.7;
			}
		}
	}

	.text {
		display: flex;
		align-items: baseline;
		gap: 8px;

		.count {
			font-size: 12px;
			font-weight: $medium;
			line-height: 145%; /* 17.4px */
			letter-spacing: 0.24px;
			opacity: 0.5;
		}
	}

	.button-close {
		cursor: pointer;
		pointer-events: auto;
		background-position: center center;
		background-image: url(../assets/images/icons/icon_close.svg);
		background-repeat: no-repeat;
		width: 20px;
		height: 20px;
		background-size: contain;
	}
</style>
